export const environment = {
  analyticsAppName: 'US HCP Dev FMTA APP',
  trackContentPrefix: 'hcp.content.',
  templateName: 'hcp-US',
  baseURL: 'https://pfizersurgicalcom-test.pfizerstatic.io/assets/videos/',
  iosAppStoreLink: '',
  androidAppStoreLink: '',
  isExternal: true,
  production: false,
  country: 'US',
  newton: {
    baseUrl: 'https://api-newton-connect-test.pfizer.com/api/v1',
    instanceId: 'dcdemoapp_instance',
    version: 3,
    countryCode: 'US',
    oAuth: {
      oAuthClient: '4b32b3a6-7f27-11ee-adc4-119fad18f45b',
      oAuthSecret: 'd8d2ebd1a0d1273ff4a7f3112aec5b1af78249fab622ce2f'
    },
    auth0ClientId: 'stZPe81I1W0b6c6rBohX03DrbDCZRu0g',
    auth0Domain: 'us-gpa-dev.pfizer.auth0.com'
  },
  firebase: {
    apiKey: 'AIzaSyDNn9HRftvxg4m9VMui59pjmJUpNv1aBsA',
    authDomain: 'surgicalfmd-us-dev-871d499b.firebaseapp.com',
    projectId: 'surgicalfmd-us-dev-871d499b',
    storageBucket: 'surgicalfmd-us-dev-871d499b.appspot.com',
    messagingSenderId: '794262413905',
    appId: '1:794262413905:web:0f7d8229de3f44d0d14e70'
  },
  fallbackLocale: 'en-US',
  locales: [
    {
      name: 'English',
      code: 'en-US'
    }
  ],
  demoAccountCredentials: {
    email: 'jetpack-demo3@pfizer.com',
    password: '336afA3@f',
    firstName: 'John',
    lastName: 'Demo'
  },
  authConfig: {
    identityProvider: 'GPA',
    domain: 'us-gpa-dev.pfizer.auth0.com',
    clientID: 'stZPe81I1W0b6c6rBohX03DrbDCZRu0g',
    audience: 'urn:pfizer-api:gpa:v1'
  }
};
